<!-- components/agenteservice/StepBar.vue -->
<template>
    <nav class="as-stepbar" aria-label="ขั้นตอน">
        <div class="as-steps" :style="{ gridTemplateColumns: `repeat(${steps.length}, 1fr)` }">
            <div v-for="(s, i) in steps" :key="i" class="as-step" :class="{
                'is-done': i < current,
                'is-active': i === current,
                'is-todo': i > current
            }">
                <!-- เส้นเชื่อมซ้าย (เริ่มตั้งแต่จุดที่ 2) -->
                <div v-if="i > 0" class="as-conn"></div>

                <!-- วงกลม -->
                <div class="as-dot">
                    <span class="as-num">{{ i + 1 }}</span>
                </div>

                <!-- ป้ายชื่อใต้จุด -->
                <div class="as-label">{{ s }}</div>
            </div>
        </div>
    </nav>
</template>

<script>
export default {
    name: 'StepBar',
    props: {
        steps: {
            type: Array,
            default: () => [
                'ตรวจสอบข้อมูล',
                'อัปโหลดเอกสาร',
                'ยืนยันการทำรายการ',
                'ชำระเงิน',
                'เสร็จสิ้น'
            ]
        },
        // 0-based
        current: { type: Number, default: 0 }
    }
}
</script>

<style scoped>
/* ต้องประกาศบน element ภายในสโคป */
.as-stepbar {
    --as-blue: #004c9c;
    --as-gray-line: #e5e7eb;
    --as-gray-dot: #d1d5db;
    --as-gray-num: #9ca3af;

    --as-dot: 30px;
    /* เส้นผ่านศูนย์กลางวงกลม */
    --as-border: 2px;
    /* ความหนาขอบวงกลม */
    --as-line-h: 4px;
    /* ความหนาเส้นเชื่อม */
    padding: 6px 0 10px;
    background: #fff;
    font-family: "DB Heavent", sans-serif;
}

.as-steps {
    display: grid !important;
    grid-template-columns: repeat(5, 1fr);
}

.as-step {
    position: relative;
    flex: 1 1 0;
    min-width: 0;
    text-align: center;
}

.as-conn {
    position: absolute;
    top: calc(var(--as-dot)/2 - var(--as-line-h)/2);
    left: calc(-50% + var(--as-dot)/2);
    width: calc(100% - var(--as-dot));
    height: var(--as-line-h);
    background: var(--as-gray-line);
    border-radius: 2px;
    z-index: 0;
}

.is-done .as-conn,
.is-active .as-conn {
    background: var(--as-blue);
}

.as-dot {
    position: relative;
    display: inline-grid;
    place-items: center;
    width: var(--as-dot);
    height: var(--as-dot);
    border-radius: 50%;
    background: #fff;
    border: var(--as-border) solid var(--as-gray-dot);
    z-index: 1;
}

.as-num {
    font-size: 18px;
    font-weight: 700;
    line-height: 1;
    color: var(--as-gray-num);
}

.is-done .as-dot {
    background: var(--as-blue);
    border-color: var(--as-blue);
}

.is-done .as-num {
    color: #fff;
}

.is-active .as-dot {
    background: #fff;
    border-color: var(--as-blue);
    box-shadow: 0 0 0 3px rgba(31, 102, 179, .16);
}

.is-active .as-num {
    color: var(--as-blue);
}

.is-todo .as-dot {
    background: #e5e7eb;
    border-color: #e5e7eb;
}

.is-todo .as-num {
    color: var(--as-gray-num);
}

.as-label {
    display: block;
    margin-top: 6px;
    font-size: 18px;
    white-space: nowrap;
    color: #111827;
}

.is-done .as-label {
    color: var(--as-blue);
    font-weight: 600;
}

.is-active .as-label {
    font-weight: 700;
}

.is-todo .as-label {
    color: var(--as-gray-num);
}

@media (max-width:640px) {
    .as-stepbar {
        --as-dot: 26px;
        --as-line-h: 3px;
    }

    .as-label {
        font-size: 18px;
    }
}

@media (max-width: 576px) {
    .as-label {
        display: none;
    }

    .is-active .as-label {
        display: block;
        white-space: nowrap;
        font-size: 12px;
    }
}
</style>
